/* batch.js — Analyse par lots : file d'attente et deux Workers, annulation,
 * pause, relance des échecs, tableau filtrable, exports CSV et HTML. */
(function () {
  'use strict';

  var MAX_WORKERS = 2;
  var F = window.MediaFormat;
  var K = window.MediaFindings;

  var entries = [];   // { id, file, status, stage, model, raw, summary, diags, report, error }
  var pool = [];      // { worker, entryId }
  var paused = false;
  var seq = 0;
  var filter = 'all';
  var els = {};

  function $(id) { return document.getElementById(id); }
  function byId(id) { for (var i = 0; i < entries.length; i++) if (entries[i].id === id) return entries[i]; return null; }

  /* ---------- Démarrage d'un lot ---------- */
  function start(files) {
    teardown();
    entries = files.map(function (f) {
      return { id: ++seq, file: f, status: 'queued', stage: null, model: null, raw: null,
        summary: '', diags: [], report: null, error: null };
    });
    paused = false; filter = 'all';
    initDom();
    els.section.hidden = false;
    if (window.App) window.App.refreshEmpty();
    var res = $('results'); if (res) res.classList.remove('visible');
    populateProfileSelect();
    setFilterButtons();
    renderAll();
    updateProgress();
    ensurePool();
    dispatch();
    els.section.scrollIntoView({ behavior: prefersReduced() ? 'auto' : 'smooth', block: 'start' });
  }

  function teardown() {
    pool.forEach(function (s) { try { s.worker.terminate(); } catch (_) {} });
    pool = [];
  }

  function ensurePool() {
    var need = Math.min(MAX_WORKERS, entries.length);
    while (pool.length < need) pool.push(makeWorker());
  }

  // Câble un Worker neuf sur un emplacement, neuf ou recyclé.
  function wire(slot) {
    var w = new Worker(new URL('./workers/analyze.worker.js', import.meta.url), { type: 'module' });
    slot.worker = w;
    slot.entryId = null;
    w.onmessage = function (e) { onMsg(slot, e.data || {}); };
    w.onerror = function (ev) {
      var e = slot.entryId != null ? byId(slot.entryId) : null;
      if (e) finishErr(e, ev.message || 'Erreur du Worker');
      slot.entryId = null; dispatch();
    };
    return slot;
  }

  function makeWorker() { return wire({ worker: null, entryId: null }); }

  function replaceWorker(slot) {
    try { slot.worker.terminate(); } catch (_) {}
    wire(slot);
  }

  /* ---------- Ordonnancement ---------- */
  function dispatch() {
    if (paused) return;
    pool.forEach(function (slot) {
      if (slot.entryId != null) return;
      var next = null;
      for (var i = 0; i < entries.length; i++) if (entries[i].status === 'queued') { next = entries[i]; break; }
      if (!next) return;
      next.status = 'analyzing'; next.stage = 'préparation';
      slot.entryId = next.id;
      updateRow(next); updateProgress();
      slot.worker.postMessage({ type: 'analyze', file: next.file, jobId: next.id });
    });
  }

  function onMsg(slot, m) {
    var e = m.jobId != null ? byId(m.jobId) : null;
    if (!e) return;
    if (e.status === 'canceled') return; // ignorer un fichier annulé entre-temps
    if (m.type === 'status') {
      e.stage = m.stage === 'engine' ? 'préparation' : 'analyse';
      updateRow(e);
    } else if (m.type === 'result') {
      finishOk(e, m.model, m.raw);
      slot.entryId = null; dispatch();
    } else if (m.type === 'error') {
      finishErr(e, m.error);
      slot.entryId = null; dispatch();
    }
  }

  function finishOk(e, model, raw) {
    if (window.App && window.App.probeBrowser && !model._probed) {
      model._probed = true;
      window.App.probeBrowser(model).then(function () { if (e.status !== 'canceled') finishOk(e, model, raw); });
      return;
    }
    e.status = 'done'; e.stage = null; e.model = model; e.raw = raw;
    e.summary = window.MediaSummary.describe(model);
    e.diags = window.MediaDiagnostics.diagnose(model);
    e.report = window.ProfilesUI ? window.ProfilesUI.evaluateWith(currentProfileId(), model) : null;
    updateRow(e); updateProgress();
  }
  function finishErr(e, detail) {
    e.status = 'error'; e.stage = null; e.error = detail || 'Échec de l’analyse';
    updateRow(e); updateProgress();
  }

  /* ---------- Actions ---------- */
  function cancel(e) {
    if (e.status === 'queued') { e.status = 'canceled'; updateRow(e); updateProgress(); return; }
    if (e.status === 'analyzing') {
      for (var i = 0; i < pool.length; i++) if (pool[i].entryId === e.id) { replaceWorker(pool[i]); break; }
      e.status = 'canceled'; e.stage = null; updateRow(e); updateProgress(); dispatch();
    }
  }
  function relaunchFailures() {
    var any = false;
    entries.forEach(function (e) { if (e.status === 'error') { e.status = 'queued'; e.error = null; any = true; updateRow(e); } });
    if (any) { updateProgress(); dispatch(); }
  }
  function togglePause() {
    paused = !paused;
    els.pause.textContent = paused ? 'Reprendre' : 'Pause';
    if (!paused) dispatch();
    updateProgress();
  }
  function recomputeVerdicts() {
    entries.forEach(function (e) {
      if (e.model) e.report = window.ProfilesUI ? window.ProfilesUI.evaluateWith(currentProfileId(), e.model) : null;
      updateRow(e);
    });
    updateProgress();
  }

  /* ---------- Profil ---------- */
  function currentProfileId() { return (els.profile && els.profile.value) || null; }
  function populateProfileSelect() {
    var sel = els.profile; if (!sel) return;
    sel.innerHTML = '';
    var none = document.createElement('option'); none.value = ''; none.textContent = '— Aucun contrôle —'; sel.appendChild(none);
    (window.ProfilesUI ? window.ProfilesUI.allProfiles() : []).forEach(function (p) {
      var o = document.createElement('option'); o.value = p.id; o.textContent = p.name + (p.statut ? ' · ' + p.statut : ''); sel.appendChild(o);
    });
    sel.value = (window.ProfilesUI && window.ProfilesUI.currentId()) || '';
  }

  /* ---------- Rendu du tableau ---------- */
  var STATUS_LABEL = { queued: 'En attente', analyzing: 'Analyse', done: 'Terminé', error: 'Erreur', canceled: 'Annulé' };
  var VERDICT_SHORT = { 'conforme': 'Conforme', 'conforme-avert': 'Avert.', 'non-conforme': 'Non conforme', 'indeterminate': 'Indéterminé' };

  function visible(e) {
    if (filter === 'all') return true;
    if (filter === 'error') return e.status === 'error';
    return e.report && e.report.verdict.code === filter;
  }

  function rowHtml(e) {
    var cont = e.model ? F.esc(e.model.container.format || '—') : '—';
    var syn = e.summary ? F.esc(truncate(e.summary, 70)) : '';
    var verdict = '—';
    if (e.report) {
      var code = e.report.verdict.code;
      verdict = '<span class="vpill ' + code + '">' + F.esc(VERDICT_SHORT[code] || code) + '</span>';
    }
    var diag = '—';
    if (e.status === 'done') {
      var n = F.gapCounts(K.collect({ diagnostics: e.diags, report: e.report }));
      diag = '<span class="gcounts">' + K.PRIORITY_ORDER.map(function (p) {
        return '<span class="gcount ' + p + (n[p] ? '' : ' zero') + '" title="' + F.esc(K.PRIORITIES[p]) + '">' +
          '<span class="sr-only">' + F.esc(K.PRIORITIES[p]) + ' : </span>' + n[p] + '</span>';
      }).join('') + '</span>';
    }
    var stateLabel = e.status === 'analyzing' ? (e.stage || 'Analyse') : STATUS_LABEL[e.status];
    var state = '<span class="bstate ' + e.status + '">' + F.esc(stateLabel) + '</span>';
    var action = '';
    if (e.status === 'queued' || e.status === 'analyzing') action = '<button class="linkbtn" data-act="cancel" data-id="' + e.id + '">Annuler</button>';
    else if (e.status === 'done') action = '<button class="linkbtn" data-act="detail" data-id="' + e.id + '">Détail</button>';
    else if (e.status === 'error') action = '<span class="berr" title="' + F.esc(e.error || '') + '">✗</span>';
    return '<tr data-id="' + e.id + '">' +
      '<td class="bfile">' + F.esc(e.file.name) + '</td>' +
      '<td>' + cont + '</td>' +
      '<td class="bsyn">' + syn + '</td>' +
      '<td>' + verdict + '</td>' +
      '<td>' + diag + '</td>' +
      '<td>' + state + '</td>' +
      '<td class="bact">' + action + '</td></tr>';
  }

  function renderAll() {
    els.rows.innerHTML = entries.filter(visible).map(rowHtml).join('');
  }
  function updateRow(e) {
    // la ligne concernée si elle est visible, sinon tout
    if (!visible(e)) { renderAll(); return; }
    var tr = els.rows.querySelector('tr[data-id="' + e.id + '"]');
    if (tr) { tr.outerHTML = rowHtml(e); } else { renderAll(); }
  }

  function updateProgress() {
    var c = { queued: 0, analyzing: 0, done: 0, error: 0, canceled: 0 };
    entries.forEach(function (e) { c[e.status]++; });
    var total = entries.length;
    var parts = [(c.done) + ' / ' + total + ' terminés'];
    if (c.analyzing) parts.push(c.analyzing + ' en cours');
    if (c.queued) parts.push(c.queued + ' en attente');
    if (c.error) parts.push(c.error + ' en erreur');
    if (c.canceled) parts.push(c.canceled + ' annulés');
    if (paused) parts.push('⏸ en pause');
    els.progress.textContent = parts.join(' · ');
    els.relaunch.disabled = c.error === 0;
    els.csv.disabled = c.done === 0;
    if (els.report) els.report.disabled = c.done === 0;
  }

  /* ---------- Exports ---------- */
  function exportReport() {
    if (!window.MediaReport) return;
    var items = entries.filter(function (e) { return e.model; }).map(function (e) {
      return { fileName: e.file.name, container: e.model.container.format, sentence: e.summary,
        report: e.report, diags: e.diags };
    });
    if (!items.length) return;
    var profName = els.profile.options[els.profile.selectedIndex] ? els.profile.options[els.profile.selectedIndex].textContent : '';
    var html = window.MediaReport.buildBatchReport(items, {
      profileName: currentProfileId() ? profName : '',
      generatedAt: (function () { try { return new Date().toLocaleString('fr-FR'); } catch (_) { return ''; } })()
    });
    var blob = new Blob([html], { type: 'text/html;charset=utf-8' });
    var a = document.createElement('a');
    a.href = URL.createObjectURL(blob); a.download = 'analyse-lot.rapport.html';
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(function () { URL.revokeObjectURL(a.href); }, 5000);
  }

  function exportCsv() {
    var items = entries.filter(function (e) { return e.model; }).map(function (e) {
      return { fileName: e.file.name, fileSize: e.file.size, model: e.model, sentence: e.summary, diags: e.diags, report: e.report };
    });
    var blob = new Blob([window.MediaReport.buildBatchCsv(items)], { type: 'text/csv;charset=utf-8' });
    var a = document.createElement('a');
    a.href = URL.createObjectURL(blob); a.download = 'analyse-lot.csv';
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(function () { URL.revokeObjectURL(a.href); }, 5000);
  }

  /* ---------- Filtres ---------- */
  function setFilterButtons() {
    Array.prototype.forEach.call(els.filters.querySelectorAll('button'), function (b) {
      b.classList.toggle('on', b.getAttribute('data-f') === filter);
    });
  }

  /* ---------- Init DOM (une fois) ---------- */
  var wired = false;
  function initDom() {
    els.section = $('batch'); els.rows = $('batchRows'); els.progress = $('batchProgress');
    els.profile = $('batchProfile'); els.pause = $('btnBatchPause');
    els.relaunch = $('btnBatchRelaunch'); els.csv = $('btnBatchCsv'); els.filters = $('batchFilters');
    els.report = $('btnBatchReport');
    if (wired) return;
    wired = true;
    els.pause.addEventListener('click', togglePause);
    els.relaunch.addEventListener('click', relaunchFailures);
    els.csv.addEventListener('click', exportCsv);
    if (els.report) els.report.addEventListener('click', exportReport);
    els.profile.addEventListener('change', function () {
      if (window.ProfilesUI) window.ProfilesUI.setSelected(els.profile.value || null);
      recomputeVerdicts();
    });
    els.filters.addEventListener('click', function (ev) {
      var b = ev.target.closest('button[data-f]'); if (!b) return;
      filter = b.getAttribute('data-f'); setFilterButtons(); renderAll();
    });
    els.rows.addEventListener('click', function (ev) {
      var b = ev.target.closest('button[data-act]'); if (!b) return;
      var e = byId(parseInt(b.getAttribute('data-id'), 10)); if (!e) return;
      if (b.getAttribute('data-act') === 'cancel') cancel(e);
      else if (b.getAttribute('data-act') === 'detail' && window.App) window.App.showDetail(e);
    });
  }

  function truncate(s, n) { s = String(s); return s.length > n ? s.slice(0, n - 1).trim() + '…' : s; }
  function prefersReduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  window.Batch = { start: start, isActive: function () { return entries.length > 0; } };
})();
